




import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BusinessHeader = () => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false); // Mobile menu state
    const dropdownRef = useRef(null);

    const handleLogout = () => {
        console.log('Logging out...');
        navigate('/');
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2 py-md-3">
            <div className="container">
                {/* Brand Logo - Responsive Scaling */}
                <Link className="navbar-brand d-flex align-items-center" to="/business/dashboard" style={{ maxWidth: '65%' }}>
                    <svg
                        width="42"
                        height="42"
                        viewBox="0 0 180 120"
                        xmlns="http://www.w3.org/2000/svg"
                        className="brand-svg-mobile"
                        style={{ marginRight: '5px' }}
                    >
                        <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                    </svg>
                    <div className="d-flex flex-column brand-text-mobile">
                        <span className="brand-title" style={{ fontSize: '0.9rem', fontWeight: '500', letterSpacing: '0.2rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                        <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.55rem', letterSpacing: '0.05rem' }}>Business Control</span>
                    </div>
                </Link>

                {/* Right side container for Dropdown + Toggler */}
                <div className="d-flex align-items-center gap-1 order-lg-last" ref={dropdownRef}>
                    {/* User Profile Dropdown */}
                    <div className="dropdown" style={{ position: 'relative' }}>
                        <button 
                            className="btn d-flex align-items-center gap-1 border-0 bg-transparent p-1 p-md-2"
                            onClick={toggleDropdown}
                            aria-expanded={showDropdown}
                        >
                            <div className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                                 style={{ 
                                     backgroundColor: '#065f46', 
                                     width: '35px', 
                                     height: '35px', 
                                     color: '#fff'
                                 }}>
                                <i className="ri-user-fill fs-5"></i>
                            </div>
                            <span className="fw-semibold text-dark d-none d-md-inline ms-1" style={{ fontSize: '0.9rem' }}>My Salon</span>
                            {/* THE DROPDOWN SYMBOL YOU REQUESTED */}
                            <i className={`ri-arrow-down-s-line small ${showDropdown ? 'rotate-180' : ''}`}></i>
                        </button>
                        
                        {/* Dropdown Menu */}
                        {showDropdown && (
                            <div 
                                className="dropdown-menu show shadow-lg border-0 rounded-3 position-absolute end-0 mt-2"
                                style={{
                                    minWidth: '200px',
                                    backgroundColor: 'white',
                                    zIndex: 1050,
                                    display: 'block'
                                }}
                            >
                                <div className="px-3 py-3 border-bottom d-md-none">
                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '0.85rem' }}>My Salon</h6>
                                </div>
                                <div className="py-2">
                                    <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="/business/profile" onClick={() => setShowDropdown(false)}>
                                        <i className="ri-user-line me-2 text-primary"></i>
                                        <span>Profile</span>
                                    </Link>
                                    <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="business/changepassword" onClick={() => setShowDropdown(false)}>
                                        <i className="ri-lock-line me-2 text-primary"></i>
                                        <span>Change Password</span>
                                    </Link>
                                    <div className="dropdown-divider my-1"></div>
                                    <button 
                                        className="dropdown-item d-flex align-items-center py-2 px-3 text-danger w-100 border-0 bg-transparent text-start" 
                                        onClick={() => { setShowDropdown(false); handleLogout(); }}
                                    >
                                        <i className="ri-logout-box-r-line me-2"></i>
                                        <span>Logout</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Navbar Toggler */}
                    <button 
                        className="navbar-toggler border-0 p-1 ms-1" 
                        type="button" 
                        onClick={() => setIsNavOpen(!isNavOpen)}
                    >
                        <span className="navbar-toggler-icon" style={{ width: '1.2em', height: '1.2em' }}></span>
                    </button>
                </div>

                {/* Navbar Links */}
                <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="adminNavbar">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 pt-3 pt-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/dashboard" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-dashboard-line me-2 d-lg-none"></i> Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/appointmentslist" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-calendar-line me-2 d-lg-none"></i> Appointments
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/staffs" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-user-line me-2 d-lg-none"></i> Staffs
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/services" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-list-check me-2 d-lg-none"></i> Services
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <style>{`
                .rotate-180 {
                    transform: rotate(180deg);
                    transition: transform 0.3s ease;
                }
                @media (min-width: 992px) {
                    .brand-title { font-size: 1.05rem !important; letter-spacing: 0.35rem !important; }
                    .brand-svg-mobile { width: 52px !important; height: 52px !important; }
                }
                @media (max-width: 991px) {
                    .navbar-collapse.show {
                        display: block;
                        background: white;
                        border-top: 1px solid #f1f1f1;
                        padding-bottom: 20px;
                    }
                    .nav-item { border-bottom: 1px solid #eee; }
                }
                .dropdown-item:hover { background-color: #f8f9fa; color: #065f46 !important; }
            `}</style>
        </nav>
    );
};

export default BusinessHeader;